/**
 * Habit Detail Page - FLO SIGNATURE DESIGN SYSTEM v2
 * Clean. Controlled. Consistent. Light ops mode.
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import HabitDetailView from '../components/HabitDetailView';
import { COLORS, SPACING, TYPOGRAPHY } from '../design/tokens';
import { Panel, Screen } from '../design/primitives';

const HabitDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/habits');
  };

  if (!id) {
    return (
      <Screen>
        <Panel style={{ textAlign: 'center', padding: SPACING[32] }}>
          <p style={{
            fontFamily: TYPOGRAPHY.body.fontFamily,
            fontSize: TYPOGRAPHY.body.sizes.default,
            color: COLORS.text.secondary,
            margin: 0
          }}>
            No habit ID provided
          </p>
        </Panel>
      </Screen>
    );
  }

  return (
    <Screen>
      <HabitDetailView
        habitId={parseInt(id, 10)}
        onBack={handleBack}
      />
    </Screen>
  );
};

export default HabitDetailPage;
